var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 384,
    viewBox: "0 0 512 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 384,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 288V232",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384 160L256 128L256 192L384 160Z",
    fill: "#DAE1E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 320V192M256 320L128 288L128 232M256 320L384 288M256 192L128 160M256 192L224 256C173.915 243.491 146.085 236.509 96 224L128 160M256 192L288 256L416 224L384 160M256 192L384 160M256 192L256 128M128 160L256 128M256 128L384 160",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.72 85.5809C308.342 86.61 307.098 87.4712 304.906 87.7555C302.768 88.0327 300.001 87.7058 297.14 86.6551C294.279 85.6045 291.958 84.0633 290.507 82.4684C289.02 80.8331 288.629 79.3713 289.007 78.3422C289.385 77.3131 290.629 76.4519 292.821 76.1676C294.959 75.8904 297.726 76.2173 300.587 77.268C303.448 78.3186 305.769 79.8598 307.219 81.4547C308.706 83.09 309.098 84.5518 308.72 85.5809Z",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M302.024 71.3107C302.053 72.7974 301.674 74.1058 301.091 75.0171C300.504 75.9355 299.786 76.3543 299.12 76.367C298.454 76.3797 297.721 75.9886 297.099 75.0933C296.482 74.2049 296.054 72.9118 296.025 71.4252C295.997 69.9385 296.376 68.63 296.959 67.7187C297.546 66.8004 298.263 66.3816 298.93 66.3689C299.596 66.3561 300.329 66.7473 300.951 67.6426C301.568 68.531 301.996 69.824 302.024 71.3107Z",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.333 74.9813C307.572 76.2593 306.56 77.1711 305.585 77.6379C304.601 78.1083 303.771 78.0855 303.198 77.7449C302.626 77.4044 302.209 76.6854 302.153 75.5967C302.098 74.5165 302.416 73.192 303.176 71.914C303.936 70.6361 304.948 69.7243 305.924 69.2575C306.907 68.7871 307.738 68.8098 308.31 69.1504C308.883 69.4909 309.299 70.21 309.355 71.2986C309.411 72.3789 309.093 73.7033 308.333 74.9813Z",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M246.247 186C224 148.5 276.542 127.601 303 123C331.481 117.76 344 91.5 311.5 85.5",
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.50d4339f7bc16d3d290c6e440c01734b.svg";
export { ForwardRef as ReactComponent };